'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var sort = exports.sort = 120;

var styles = exports.styles = function styles(_styles, props) {
	var columns = {
		'xsm': props.xsm,
		'sm': props.sm,
		'md': props.md,
		'lg': props.lg,
		'xlg': props.xlg
	};

	return _extends({}, _styles, columns);
};

var config = exports.config = function config() {
	return {
		label: 'Columns Settings',
		props: [{
			name: 'xsm',
			inputType: 'slider',
			label: 'Columns mobile (small)',
			default: '2'
		}, {
			name: 'sm',
			inputType: 'slider',
			label: 'Columns mobile',
			default: '2'
		}, {
			name: 'md',
			inputType: 'slider',
			label: 'Columns tablet',
			default: '3'
		}, {
			name: 'lg',
			inputType: 'slider',
			label: 'Columns desktop',
			default: '4'
		}, {
			name: 'xlg',
			inputType: 'slider',
			label: 'Columns desktop (large)',
			default: '4'
		}]
	};
};